type KnownNextRepeatedSlashErrorInput = {
  pathname: string;
  originalError: unknown;
  errorClass?: string;
  errorMessage?: string;
};

/**
 * Next.js の既知問題で、先頭に重複スラッシュがある不正 URL を処理した際に発生する
 * History.replaceState の SecurityError だけを識別します。
 * 条件が不足する場合は通知を残すため false を返します。
 *
 * @see https://github.com/vercel/next.js/issues/70948
 */
export function isKnownNextRepeatedSlashError({
  pathname,
  originalError,
  errorClass,
  errorMessage,
}: KnownNextRepeatedSlashErrorInput): boolean {
  if (!/^\/{2,}/.test(pathname)) return false;

  const originalErrorName =
    originalError && typeof originalError === "object"
      ? (originalError as { name?: unknown }).name
      : undefined;
  const originalErrorMessage =
    originalError && typeof originalError === "object"
      ? (originalError as { message?: unknown }).message
      : undefined;

  const isSecurityError =
    originalErrorName === "SecurityError" || errorClass === "SecurityError";
  if (!isSecurityError) return false;

  return [originalErrorMessage, errorMessage].some(
    (message) =>
      typeof message === "string" &&
      message.includes("replaceState") &&
      message.includes("History"),
  );
}
